<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div
    *ngIf="
      aircraftEventBusinessPersonAudits && aircraftEventBusinessPersonAudits.length > 0;
      else noAudits
    "
  >
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftEventBusinessPersonAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Aircraft Event Business Person audits </ng-template>
</ng-template>
